import { render, staticRenderFns } from "./recomedShopInClass2.vue?vue&type=template&id=bb34efac&scoped=true"
import script from "./recomedShopInClass2.vue?vue&type=script&lang=js"
export * from "./recomedShopInClass2.vue?vue&type=script&lang=js"
import style0 from "./recomedShopInClass2.vue?vue&type=style&index=0&id=bb34efac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb34efac",
  null
  
)

export default component.exports